module.exports = __webpack_public_path__ + "img/sosial4.b1a18532.svg";